/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { NotificationCategoryFromJSON, NotificationCategoryToJSON, } from './NotificationCategory';
/**
 * Check if a given object implements the NotificationPreferenceUpdate interface.
 */
export function instanceOfNotificationPreferenceUpdate(value) {
    let isInstance = true;
    return isInstance;
}
export function NotificationPreferenceUpdateFromJSON(json) {
    return NotificationPreferenceUpdateFromJSONTyped(json, false);
}
export function NotificationPreferenceUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': !exists(json, 'category') ? undefined : NotificationCategoryFromJSON(json['category']),
        'emailEnabled': !exists(json, 'emailEnabled') ? undefined : json['emailEnabled'],
        'inAppEnabled': !exists(json, 'inAppEnabled') ? undefined : json['inAppEnabled'],
    };
}
export function NotificationPreferenceUpdateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': NotificationCategoryToJSON(value.category),
        'emailEnabled': value.emailEnabled,
        'inAppEnabled': value.inAppEnabled,
    };
}
